<template>
  <header class="app-header">
    <b-navbar toggleable="lg">
      <b-navbar-brand href="/home">
        <span>NHC</span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <app-button
            v-if="ProgramExists('UserActivities')"
            href="/modules"
            :class="{ 'is-active': isModulesActive }"
            variant="tertiary"
          >
            <b-icon icon="journals" shift-v="2" />
            {{ $t('Modules') }}
          </app-button>
          <app-button
            v-if="ProgramExists('Conversations')"
            href="/berichten"
            :class="{ 'is-active': isMessagesActive }"
            variant="tertiary"
          >
            <b-icon icon="chat" shift-v="2" />
            {{ $t('Messages') }}
          </app-button>
          <app-button
            v-if="ProgramExists('CoachActivities')"
            href="/clienten"
            :class="{ 'is-active': isClientsActive }"
            variant="tertiary"
          >
            <b-icon icon="people" shift-v="2" />
            {{ $t('Clients') }}
          </app-button>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="!isLoggedIn" right @click="login">
            {{ $t('Login') }}
          </b-nav-item>
          <b-nav-item-dropdown v-if="isLoggedIn" right>
            <template v-slot:button-content>
              <span>
                {{ currentUser.profile.nickname }}
              </span>
            </template>
            <b-dropdown-item v-if="isLoggedIn" :href="profileUri">
              {{ $t('Profile') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="!isLoggedIn"
              @click="login"
            ></b-dropdown-item>
            <b-dropdown-item v-if="isLoggedIn" @click="logout">
              {{ $t('Logout') }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
  import { mapState } from 'vuex'
  import AppButton from '../AppButton/AppButton'
  import auth from '../../auth/index'

  export default {
    components: { AppButton },
    computed: {
      ...mapState('context', {
        currentUser: state => state.currentUser,
        currentAuthorizedActivities: state => state.currentAuthorizedActivities,
      }),
      isHomeActive() {
        return this.$route.path.includes('home')
      },
      isModulesActive() {
        return this.$route.path.includes('modules') && !this.isClientsActive
      },
      isMessagesActive() {
        return this.$route.path.includes('berichten')
      },
      isClientsActive() {
        return (
          this.$route.path.includes('clienten') ||
          this.$route.path.includes('nieuwe-client')
        )
      },
      isLoggedIn() {
        return !!this.currentUser
      },
      profileUri() {
        return `${process.env.VUE_APP_AUTH_AUTHORITY}/manage?returnClientUrl=${window.location.href}`
      },
    },
    created() {
      this.setContext()
      this.$store.dispatch('context/getAuthorizedActivities')
    },
    methods: {
      setContext() {
        const currentActivityKey =
          document.querySelector('meta[name="current-activity-key"]').content ||
          this.$route.query.key
        const currentPersonId =
          document.querySelector('meta[name="current-person-id"]').content ||
          this.$route.query.currentPersonId

        this.$store.commit('context/setContextKey', {
          currentActivityKey,
          currentPersonId,
        })
      },
      login() {
        auth.getUserRedirect()
      },
      logout() {
        auth.signOut()
      },
      ProgramExists(program) {
        return this.currentAuthorizedActivities.length > 0
          ? this.currentAuthorizedActivities.filter(
              activity => activity.program.type === program,
            ).length > 0
          : false
      },
    },
  }
</script>

<style lang="scss" src="./AppHeader.scss"></style>

<i18n>
  {
    "en": {
      "Home": "Home",
      "Modules": "Modules",
      "Messages": "Messages",
      "Clients": "Clients",
      "Profile": "Profile",
      "Login": "Login",
      "Logout": "Logout"
    },
    "nl": {
      "Home": "Home",
      "Modules": "Modules",
      "Messages": "Berichten",
      "Clients": "Cliënten",
      "Profile": "Profiel",
      "Login": "Inloggen",
      "Logout": "Uitloggen"
    }
  }
</i18n>
